import { Grid, Typography } from '@mui/material';

import '../styles/CreatePage.scss';

interface Props {
  title: string;
  text: string;
  width?: number;
}

const StepDescription = ({ title, text, width }: Props) => {
  return (
    <Grid item xs={width ?? 12} xl={4} className="step-item">
      <Typography className="step-title">{title}</Typography>
      <Typography className="step-text">{text}</Typography>
    </Grid>
  );
};

export default StepDescription;
